import script from "./sf-markdown-toolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-markdown-toolbar.vue?vue&type=script&setup=true&lang=ts"

import "./sf-markdown-toolbar.vue?vue&type=style&index=0&id=683f203f&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-683f203f"]])

export default __exports__